import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'cardTitle'
	| 'confirmButton'
	| 'expandSection'
	| 'collapseSection'
	| 'successPill';

export const messages: Record<
	MessageKeys,
	{ id: string; defaultMessage: string; description?: string }
> = defineMessages({
	cardTitle: {
		id: 'ai-mate.conversation-assistant-message-actions.select-hardware-types.card-title',
		defaultMessage: 'Select hardware types',
		description: 'Card title when selecting JSM hardware types',
	},
	confirmButton: {
		id: 'ai-mate.conversation-assistant-message-actions.select-hardware-types.confirm-button',
		defaultMessage: 'Start setup',
		description: 'Label for the confirm button when selecting hardware types',
	},
	expandSection: {
		id: 'ai-mate.conversation-assistant-message-actions.select-hardware-types.expand-section',
		defaultMessage: 'Show more',
		description: 'Accessible label for expanding the hardware types card body',
	},
	collapseSection: {
		id: 'ai-mate.conversation-assistant-message-actions.select-hardware-types.collapse-section',
		defaultMessage: 'Show less',
		description: 'Accessible label for collapsing the hardware types card body',
	},
	successPill: {
		id: 'ai-mate.conversation-assistant-message-actions.select-hardware-types.success-pill',
		defaultMessage: 'Hardware types selected successfully',
		description: 'Pill message shown after hardware types selection succeeds',
	},
});
